import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

type SlideContextValue = {
    product: Product<ProductFieldSet.ProductTile>;
};

type SlideContextProviderProps = {
    product: Product<ProductFieldSet.ProductTile>;
    children: ReactNode;
};

export const SlideContext = createContext<SlideContextValue | undefined>(
    undefined
);
SlideContext.displayName = "SlideContext";

export const SlideContextProvider = ({
    product,
    children
}: SlideContextProviderProps) => {
    return <SlideContext value={{ product: product }}>{children}</SlideContext>;
};

export const useSlideContext = () => {
    const context = use<SlideContextValue | undefined>(SlideContext);

    if (!isDefined(context)) {
        throw new Error(`${SlideContext.displayName} is undefined.`);
    }

    return context;
};
